<template>
  <div class="app">

    <div class="op-wrapper custom-wrapper"
      v-if="hasRes('app_info_create')">
      <el-button
        type="danger"
        size="medium"
        @click="appFormDialogVisible = true">添加应用号</el-button>
    </div>

    <custom-table
      :data="appInfoList"
      v-if="hasRes('app_info_index')"
      @data-change="updateTableData">

      <el-table-column
        prop="app_id"
        label="应用 ID"
        sortable="custom" >
      </el-table-column>

      <el-table-column
        prop="app_name"
        label="应用名"
        sortable="custom" >
      </el-table-column>

      <el-table-column
        prop="remarks"
        label="备注"
        sortable="custom" >
      </el-table-column>

      <el-table-column
        prop="type"
        label="应用类型"
        sortable="custom" >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.type === 0 ? 'primary' : 'danger'"
            size="mini"
            disable-transitions>{{ scope.row.type === 0 ? '普通版' : '定制版' }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作"
        align="center"
        width="200"
        v-if="hasRes('bin_info_index')"
        header-align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="jumpToBin(scope.row)">升级包管理</el-button>
        </template>
      </el-table-column>
    </custom-table>

    <custom-paginate
      :count="appInfoCount"
      v-if="hasRes('app_info_index')"
      @page-change="updateTableData">
    </custom-paginate>

    <dialog-app-form
      @data-change="updateTableData"
      v-if="hasRes('app_info_create')"
      :visible.sync="appFormDialogVisible">
    </dialog-app-form>

  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'
import DialogAppForm from '@/components/app/DialogAppForm'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_LOADING } from '@/store/modules/table'

export default {
  name: 'App',
  components: {
    CustomTable,
    CustomPaginate,
    DialogAppForm
  },
  data () {
    return {
      appFormDialogVisible: false
    }
  },
  computed: {
    ...mapState('app', [
      'appInfoList',
      'appInfoCount'
    ]),
    ...mapState('table', [
      'page',
      'pageSize',
      'sort',
      'filters'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_LOADING
    ]),
    ...mapActions('app', [
      'getAppInfos'
    ]),

    jumpToBin (appInfo) {
      this.$router.push({
        name: 'Bin',
        query: {
          'app_id': appInfo.app_id
        }
      })
    },

    // 更新表格数据
    async updateTableData () {
      if (!this.hasRes('app_info_index')) return

      this.setLoading(true)

      try {
        await this.getAppInfos({
          page: this.page,
          pageSize: this.pageSize,
          sort: this.sort,
          filters: this.filters
        })

        this.setLoading(false)
      } catch (err) {
        console.log(err)
        this.setLoading(false)

        this.$message({
          type: 'error',
          message: '获取应用号列表失败'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/base";

.app-wrapper {

  .op-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/app/App.vue